import { Dropdown } from "react-bootstrap";
import ResultsPagination from "./ResultsPagination";

const ResultsHeader = ({
  searchKeyword,
  perPage,
  setPerPage,
  setActivePage,
  activePage,
  totalPages,
  total,
  sortOption,
  setSortOption,
  sortOptions = [], // ✅ dynamic from backend
 hideShowPerPage = false,
  perPageOptions = []
}) => {

  // ✅ SAFE LABEL (FIXES EMPTY / SMALL ISSUE)
  const selectedLabel =
    sortOptions?.find(opt => opt.value === sortOption)?.label || sortOptions?.[0]?.label

  const start = total === 0 ? 0 : (activePage - 1) * perPage + 1;
  const end = Math.min(activePage * perPage, total);

  return (
    <div className="mb-4">

      {/* 🔹 RESULT COUNT */}
      {searchKeyword && (
        <div className="mb-3 px-4">
          <span style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937" }}>
            {start}–{end} of {total}{" "}
          </span>
          <span style={{ fontSize: "16px", color: "#6b7280" }}>
            Showing results using the keyword{" "}
            <span style={{ color: "#0891b2", fontWeight: "500" }}>
              '{searchKeyword}'
            </span>
          </span>
        </div>
      )}

      <div className="d-flex align-items-center  flex-wrap gap-3">

        <div className="d-flex align-items-center gap-2 flex-grow-1">
          {!hideShowPerPage && (
            <div
              className="d-flex align-items-center"
              style={{ gap: "8px", whiteSpace: "nowrap" }}
            >
              <span style={{ fontSize: "14px", color: "#374151", fontWeight: "500" }}>
                Sort by:
              </span>

             <select
  className="form-select"
  style={{
    borderRadius: "8px",
    border: "1px solid #000",
    height: "43px",
    minWidth: "150px",
    fontSize: "14px",
    cursor: "pointer"
  }}
  value={sortOption}
  onChange={(e) => {
    setSortOption(e.target.value);
    setActivePage(1); // keep your fix
  }}
>
  {sortOptions?.length > 0 ? (
    sortOptions.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))
  ) : (
    <option disabled>Loading...</option>
  )}
</select>
            </div>
          )}
        </div>

        {/* 🔹 RIGHT SIDE (PAGINATION) */}
        <div className="d-flex justify-content-center justify-content-md-end  w-md-auto">
        <ResultsPagination
  activePage={activePage}
  setActivePage={setActivePage}
  perPage={perPage}
  setPerPage={setPerPage}
  totalPages={totalPages}
   perPageOptions={perPageOptions}
/>
        </div>

      </div>
    </div>
  );
};

export default ResultsHeader;